import { NgModule } from '@angular/core';
import { LibFaqIconComponent } from './lib-faq-icon.component';

@NgModule({
  declarations: [LibFaqIconComponent],
  exports: [LibFaqIconComponent],
})
export class LibFaqIconModule {}
